import { api } from "./api.ts";

export type EmailTemplateResponse = {
  subject: string;
  body: string;
  // Only rated_age_request returns this: its recipient is a fixed vendor
  // address the backend picks, not something the caller already knows and
  // passes in like the ack email's recipientEmail.
  recipient?: string;
};

export const emailApi = api.injectEndpoints({
  endpoints: (build) => ({
    getEmailTemplate: build.query<
      EmailTemplateResponse,
      {
        emailType: string;
        fileId: string | number;
        recipientEmail?: string;
        serviceType?: string;
      }
    >({
      query: ({ emailType, fileId, recipientEmail, serviceType }) => ({
        url: "api/v1/email-templates/",
        method: "GET",
        params: {
          email_type: emailType,
          file_id: fileId,
          ...(recipientEmail && { recipient_email: recipientEmail }),
          ...(serviceType && { service_type: serviceType }),
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useLazyGetEmailTemplateQuery } = emailApi;
